import { Moment } from "moment";
import { ContactRequestQuotationProduct } from "./contact-request-quotation-product";
import { Currency } from "./currency";
import Decimal from 'decimal.js';

export class ContactRequestQuotation {

    constructor(
        public description: string,
        public comment: string,
        public productList: ContactRequestQuotationProduct[],
        public baseCurrency: Currency,
        public secondCurrency: Currency,
        public quotationDate: Moment | null,
        public dueDate: Moment | null,
        public deposit: Decimal,
        public priceIncludes: string,
        public priceNotIncludes: string,
        public id?: number
    ){}
}
